<script setup>
import { onMounted, useTemplateRef } from 'vue';

const props = defineProps({
  cardComponent: {
    type: Object,
    required: true,
  },
  cardComponentProps: {
    type: Object,
    default: null,
  },
  fetchLocations: {
    type: Function,
    required: true,
  },
  locations: {
    type: Array,
    default: null,
  },
  range: {
    type: Object,
    default: null,
  },
});

const {
  addIntersectionObserver,
  removeIntersectionObserver,
  limit,
  skip,
} = useInfiniteScroll();
const locationList = useTemplateRef('locationList');

const setupIntersectionObserver = () =>
  addIntersectionObserver(locationList.value, () => props.fetchLocations(limit.value, skip.value));

onMounted(setupIntersectionObserver);

watch(() => props.locations, (newValue, oldValue) => {
  if (newValue?.length === 0 && oldValue?.length > 0) {
    // Remove intersection observer when locations are reset
    removeIntersectionObserver();
    skip.value = 0;
  }
  else if (newValue?.length > 0 && oldValue?.length === 0) {
    setupIntersectionObserver();
  }
});
</script>

<template>
  <ul
    ref="locationList"
  >
    <li
      v-for="location in locations"
      :key="location.id"
      class="tw-mb-2.5"
    >
      <Component
        :is="cardComponent"
        :location="location"
        :range="range"
        v-bind="cardComponentProps"
      />
    </li>
  </ul>
</template>
